<div #commentsContainer class="comments-container">

    <!-- Only generate the comments container if it is visible because one may have a lot of comments -->
    <!-- in which case the DOM gets bloated ... and if nobody can see it, it's a waste of performance -->
    @if (!hidden()) {
        @if (accountsWithComments().length === 0) {
            <div class="empty-comment-text">No comments yet</div>
        }
        @else {
            @for (a of accountsWithComments(); track a.id) {
                <div [style.display]="a.hidden ? 'none' : 'block'" [attr.data-index]="$index" class="comment-box">
                    <div class="comment-header">
                        <div>
                            {{a.account.uwbId}},
                            @if (a.multifield) {<fluent-badge>{{a.attributeName}}</fluent-badge>}
                        </div>
                        <div [title]="a.account.account">{{a.account.account}}</div>
                        <i class="fal fa-square-arrow-up-right" (click)="onCellPaneCommentClick(a)"></i>
                    </div>
                    <app-account-comments-editor [segment]="segment()" [account]="a.account" [field]="a.attribute"
                                                 (onCommentsUpdated)="onCommentsUpdated(a)">
                    </app-account-comments-editor>
                </div>
            }
        }
    }
</div>

<!-- Search text input to filter comments -->
<div class="layout-hbox" style="gap: 5px; border-bottom: 1px solid lightgray; padding: 0 4px 2px 4px; margin-bottom: 5px;">
    <fluent-text-input #filterTextInput class="search-filter-input" placeholder="Filter Comments" type="text"
                       (input)="onFilterChange(filterTextInput, commentsContainer)">
        <i slot="end" class="fal fa-xmark" style="font-size: 12px; cursor: pointer" (click)="clearFilter(filterTextInput, commentsContainer)"></i>
    </fluent-text-input>
</div>
